import { Link } from 'react-router-dom'
import useProductCategories from '../../hooks/useProductCategories'

export const WhatsNewCard = ({ item }) => {
  const { getCategoryNameById } = useProductCategories()

  return (
    <Link to={`/retailers/${item.shopSlug}/products/${item.productSlug}`}>
      <div className="flex-shrink-0 w-32">
        <div className="relative h-28 rounded-md overflow-hidden mb-2 flex items-center justify-center bg-background">
          <img
            src={item.primaryImageUrl}
            alt={item.name || 'New item'}
            className="object-contain max-h-full max-w-full"
          />
        </div>
        <div className="space-y-1">
          <p className="text-sm font-medium text-gray-800 truncate text-center">
            {item.name || 'Product Name'}
          </p>
          <p className="text-xs text-gray-600 truncate text-center">
            {getCategoryNameById(item.categoryId)}
          </p>
          <p className="text-sm font-bold text-secondary-600 text-center">
            {item.priceText || 'Price N/A'}
          </p>
        </div>
      </div>
    </Link>
  )
}
